import {
  BasicContractObject,
  ContractPartyType,
} from '@a_team/models/dist/ContractObject';
import TextButton from '@src/components/TextButton';
import React, { FC, ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import { Button, Colors } from '@ateams/components';
import { useStores } from '@src/stores';

const useStyles = createUseStyles({
  buttonsContainer: {
    display: 'flex',
    gap: 10,
    justifyContent: 'center',
  },
  linkButton: {
    color: Colors.secondary,
  },
  signButton: {
    backgroundColor: Colors.secondaryDark,
    color: Colors.light,
    borderRadius: 4,
    padding: '6px 12px',
    height: 34,
    fontSize: 12,
    width: 'auto',
    fontWeight: 400,
  },
});

const PandadocContractActions: FC<{
  contract: BasicContractObject;
}> = ({ contract }): ReactElement => {
  const styles = useStyles();
  const {
    auth,
    missions: { currentMission },
  } = useStores();

  const builderParty = contract.parties.find(
    ({ type }) => type === ContractPartyType.MissionRole,
  );

  const isBuilder = builderParty?.user?.uid === auth.uid;
  const isSignedByBuilder = !!builderParty?.signedAt;

  const handleSign = async () => {
    if (!currentMission) return;
    const contractData = await currentMission.getPandadocContract(contract.sid);
    window.open(contractData.signingURL, '_blank');
  };

  const handleDownload = async () => {
    if (!currentMission) return;
    const contractData = await currentMission.getPandadocContract(contract.sid);
    window.open(contractData.downloadURL, '_blank');
  };

  const handleView = async () => {
    window.open(
      `https://app.pandadoc.com/a/#/documents/${contract.pandadocId}`,
      '_blank',
    );
  };

  return (
    <div className={styles.buttonsContainer}>
      {(!isBuilder || isSignedByBuilder) && (
        <TextButton className={styles.linkButton} onClick={handleView}>
          View
        </TextButton>
      )}
      {(!isBuilder || isSignedByBuilder) && (
        <TextButton className={styles.linkButton} onClick={handleDownload}>
          Download
        </TextButton>
      )}
      {isBuilder && !isSignedByBuilder && (
        <Button className={styles.signButton} onClick={handleSign}>
          Sign agreement
        </Button>
      )}
    </div>
  );
};

export default PandadocContractActions;
